import queries from '@apis/queries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

const HJM_ID = '4150468217112520';

function useTestUser(): boolean {
    const { user } = useUser();
    const { status } = useQuery({
        ...queries.testUser.isTestUser(),
        enabled: !!user,
    });
    return status === 'success' || user?.barcodeNo === HJM_ID;
}

export default useTestUser;
